var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-top',{attrs:{"transmitData":_vm.transmitData}}),_c('div',{style:({ height: _vm.tableHeight  + 'px' }),attrs:{"id":"sign-content"},on:{"click":_vm.toggleBox}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }